<template>
    <div class="d-flex flex-wrap">
        <div class="col-12 text-center">
            <h4 class="text-third">
                {{ $t('Auth.ForgotPasswordRequestInProgress.progress') }}
            </h4>
        </div>
        <div class="col-12 text-center my-4">
            <span class="text-second">
                <i class="fa-solid fa-key text-icon forgot_password_check"></i>
            </span>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'ForgotPasswordRequestInProgress',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        forgot_password() {
            this.$http
                .post(`${this.apiPath}/forgot_password`, { token: this.$route.query.token }, {
                    headers: {
                        "x-api-key": this.omsApiKey
                    },
                })
                .then((res) => {
                    switch (res.data) {
                        case 'Request Expired':
                            this.$toast.error(this.$t('Auth.RequestExpired.expired'))
                            this.$router.replace('/')
                            break;
                        default:
                            this.$router.replace({
                                path: '/reset_password',
                                query: { token: res.data }
                            })
                            break;
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    },
    created() {
        this.forgot_password()
    }
}
</script>